"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var document_templates_controller_1 = __importDefault(require("./document-templates.controller"));
var document_templates_html_1 = __importDefault(require("./document-templates.html"));
var document_template_model_1 = __importDefault(require("../../common/models/document-template-model"));
var document_editor_module_1 = __importDefault(require("../directives/document-editor/document-editor.module"));
var create_document_module_1 = __importDefault(require("./create-document/create-document.module"));
var edit_document_module_1 = __importDefault(require("./edit-document/edit-document.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.documenttemplates", {
        url: "/document-templates",
        controller: "AdminDocumentTemplatesController",
        controllerAs: "vm",
        template: document_templates_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.documenttemplates", [
    create_document_module_1.default.name,
    edit_document_module_1.default.name,
    document_editor_module_1.default.name,
])
    .config(config)
    .controller("AdminDocumentTemplatesController", document_templates_controller_1.default)
    .service("DocumentTemplateModel", document_template_model_1.default);
